<div class="flexBoxOuter">
    <div class="video-container">
        <h3>Student Audio</h3>
        <app-vjs-player *ngIf="showStudentVideoPlayer" [options]="optionsForStudentVideo"></app-vjs-player>
        <app-loading-spinner class="loadingSpinner"
            *ngIf="!showStudentVideoPlayer && !ShowNoAudioStudentTxt"></app-loading-spinner>
        <p *ngIf="ShowNoAudioStudentTxt">There is no audio for the student</p>
    </div>
    <div class="video-container">
        <h3>{{botName}} Audio</h3>
        <app-vjs-player *ngIf="showBotVideoPlayer" [options]="optionsForBotVideo"></app-vjs-player>
        <app-loading-spinner class="loadingSpinner"
            *ngIf="!showBotVideoPlayer && !ShowNoAudioBotTxt"></app-loading-spinner>
        <p *ngIf="ShowNoAudioBotTxt">There is no audio for {{botName}}</p>
    </div>
</div>